import { WP_Image } from "@/models";

interface Props {
	image: WP_Image;
}

export function IntroBottle({ image }: Props) {
	const arrayOfSizes = [
		"bottle_10x32",
		"bottle_17x60",
		"bottle_23x80",
		"bottle_35x120",
		"bottle_46x160",
		"bottle_69x240",
		"bottle_84x290",
		"bottle_96x334",
		"bottle_110x380",
		"bottle_133x460",
		"bottle_165x570",
		"bottle_188x650",
		"bottle_192x668",
		"bottle_220x760",
		"bottle_260x900",
		"bottle_347x1200",
		"bottle_404x1400",
		"bottle_433x1500",
		"bottle_462x1600",
		"bottle_491x1700",
		"bottle_520x1800",
	];

	const srcSet = arrayOfSizes
		.map((size) => {
			if (image.media_details?.sizes?.[size]) {
				return `${image.media_details.sizes[size].source_url} ${image.media_details.sizes[size].width}w`;
			}
		})
		.filter((n) => n);

	return (
		<img
			src={image.media_details.sizes["bottle_96x334"]?.source_url || ""}
			srcSet={srcSet.join(", ")}
			alt={!!image.alt_text ? image.alt_text : undefined}
			loading="eager"
		/>
	);
}
